import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import content from './content.json'
import * as N from './style'

const FooterEl = styled.footer`
  background: ${N.t.white};
  border-top: 1px solid ${N.t.borderSoft};
  padding: 32px 0;
`

const Inner = styled(N.Container)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const TopRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  text-align: center;
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    text-align: left;
  }
`

const BrandBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Brand = styled(NavLink)`
  font-family: ${N.t.fontHeading};
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: ${N.t.slate950};
  text-decoration: none;
`

const Tagline = styled.p`
  font-size: 0.875rem;
  color: ${N.t.slate500};
`

const ProductsBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  @media (min-width: 768px) {
    align-items: flex-start;
  }
`

const ProductsTitle = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${N.t.slate500};
`

const ProductsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  list-style: none;
  margin: 0;
  padding: 0;
`

const ProductLink = styled.a`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${N.t.slate700};
  text-decoration: none;
  transition: color 0.15s ease;
  &:hover {
    color: ${N.t.blue600};
  }
`

const BottomRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
  padding-top: 16px;
  border-top: 1px solid ${N.t.borderSubtle};
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }
`

const NoxFooter = () => {
  return (
    <FooterEl>
      <Inner>
        <TopRow>
          <BrandBlock>
            <Brand to='/'>{content.site.name}</Brand>
            <Tagline>{content.site.tagline}</Tagline>
          </BrandBlock>
          <ProductsBlock>
            <ProductsTitle>{content.footer.products_title}</ProductsTitle>
            <ProductsList>
              {content.footer.products.map(p => (
                <li key={p.name}>
                  <ProductLink href={p.url} target='_blank' rel='noopener noreferrer'>
                    {p.name}
                  </ProductLink>
                </li>
              ))}
            </ProductsList>
          </ProductsBlock>
        </TopRow>
        <BottomRow>
          <Tagline>© {new Date().getFullYear()} NOX</Tagline>
        </BottomRow>
      </Inner>
    </FooterEl>
  )
}

export default NoxFooter
